import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Sync = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 23 22"
        xmlns="http://www.w3.org/2000/svg"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          fill={props.color || theme.palette.grey600}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1622 5.25542C19.1237 4.92386 18.8419 4.6665 18.5 4.6665L18.4223 4.67099C18.0907 4.7095 17.8333 4.99128 17.8333 5.33317L17.8343 8.17352C16.4579 6.02681 14.1435 4.6665 11.5833 4.6665C8.43518 4.6665 5.6585 6.72347 4.54079 9.77023C4.41398 10.1159 4.59139 10.4989 4.93706 10.6257C5.28272 10.7525 5.66574 10.5751 5.79254 10.2294C6.72255 7.69436 9.00997 5.99984 11.5833 5.99984C13.8397 5.99984 15.8762 7.30261 16.9707 9.33249L13.8333 9.33317L13.7556 9.33766C13.424 9.37617 13.1667 9.65795 13.1667 9.99984C13.1667 10.368 13.4651 10.6665 13.8333 10.6665H18.5L18.5777 10.662C18.9093 10.6235 19.1667 10.3417 19.1667 9.99984V5.33317L19.1622 5.25542ZM10.5 13.9998C10.5 13.6316 10.2015 13.3332 9.83333 13.3332H5.16666L5.08892 13.3377C4.75736 13.3762 4.5 13.6579 4.5 13.9998V18.6665L4.50448 18.7443C4.54299 19.0758 4.82477 19.3332 5.16666 19.3332L5.24441 19.3287C5.57597 19.2902 5.83333 19.0084 5.83333 18.6665L5.83233 15.8265C7.20849 17.9729 9.52322 19.3332 12.0833 19.3332C15.2315 19.3332 18.0082 17.2762 19.1259 14.2294C19.2527 13.8838 19.0753 13.5008 18.7296 13.374C18.3839 13.2471 18.0009 13.4246 17.8741 13.7702C16.9441 16.3053 14.6567 17.9998 12.0833 17.9998C9.82677 17.9998 7.78983 16.6969 6.69583 14.6672L9.83333 14.6665L9.91108 14.662C10.2426 14.6235 10.5 14.3417 10.5 13.9998Z"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.404 6.276L18.8073 4.87267C19.2473 4.43267 20 4.744 20 5.36667V10.6667H14.7C14.078 10.6667 13.766 9.914 14.206 9.474L15.5213 8.15867C14.5407 7.21667 13.2273 6.66667 11.85 6.66667C9.686 6.66667 7.82533 7.972 7.00467 9.836C6.78733 10.3287 6.32467 10.6667 5.78667 10.6667H5.73867C4.79533 10.6667 4.16467 9.69867 4.53667 8.832C5.75467 5.994 8.57133 4 11.85 4C13.9373 4 15.9273 4.83933 17.404 6.276ZM18.2133 13.3333H18.2613C19.2047 13.3333 19.8353 14.3013 19.4633 15.168C18.2453 18.006 15.4287 20 12.15 20C10.0627 20 8.07267 19.1607 6.596 17.724L5.19267 19.1273C4.75267 19.5673 4 19.256 4 18.6333V13.3333H9.3C9.92267 13.3333 10.234 14.086 9.794 14.526L8.47867 15.8413C9.45867 16.7833 10.7727 17.3333 12.15 17.3333C14.314 17.3333 16.1747 16.028 16.9953 14.164C17.2127 13.6713 17.6753 13.3333 18.2133 13.3333Z"
      />
    </svg>
  );
};
